import './CensusValidatingStep.scss';
import { useTranslation } from 'react-i18next';

import Spinner from '../../../../../../../../../shared/components/Globals/Spinner/Spinner';
import { TRANSLATIONS_QUOTES } from '../../../../../../../../../shared/translations/quotes';

export default function CensusValidatingStep() {
  const { t } = useTranslation();

  return (
    <div className="census-step census-step--centered">
      <Spinner size={24} variant="svg" aria-label={t(TRANSLATIONS_QUOTES.create.censusModal.validatingStatus)} />
      <div className="census-status-label">{t(TRANSLATIONS_QUOTES.create.censusModal.validatingStatus)}</div>
    </div>
  );
}
